import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleSummaryComponent } from './article-summary/article-summary.component';
import { ListArticlesComponent } from './list-articles/list-articles.component';
import { SingleArticleComponent } from './single-article/single-article.component';
import { NewArticleComponent } from './new-article/new-article.component';
import { ArticleService } from './blog-services/article.service';
import { BlogRoutingModule } from './blog-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmNewArticleComponent } from './confirm-new-article/confirm-new-article.component';
import { TemplateArticleComponent } from './template-article/template-article.component';
import { PageListBlogComponent } from './page-list-blog/page-list-blog.component';


@NgModule({
    declarations: [
        SingleArticleComponent,
        ListArticlesComponent,
        ArticleSummaryComponent,
        NewArticleComponent,
        ConfirmNewArticleComponent,
        TemplateArticleComponent,
        PageListBlogComponent
    ],
    imports: [
        CommonModule,
        BlogRoutingModule,
        ReactiveFormsModule
    ],
    providers: [
        ArticleService
    ],
    exports: [
        ArticleSummaryComponent,
        ListArticlesComponent
    ]
})
export class BlogModule { }
